import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './containers/Home/home';
import Gallery from './containers/Gallery/gallery';
import Writer from './containers/Writer/writer';
import Vo from './containers/Vo/vo';
import Actress from './containers/Actress/actress';
import Contact from './containers/Contact/contact';
import Nav from './components/Nav/nav';
import ShadowBanner from './components/ShadowBanner/shadowbanner';
import Footer from './components/Footer/footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

import './App.scss';

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <ShadowBanner />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/screenwriter" element={<Writer />} />
          <Route path="/vo" element={<Vo />} />
          <Route path="/actress" element={<Actress />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
};

export default App;
